import styled from 'styled-components';
import ListSection from '../ListSection';
var Instructions = styled(ListSection).withConfig({
  displayName: "Lingeriestyles__Instructions",
  componentId: "sc-1sp9jbm-0"
})(["&&{h2{font-size:", ";font-weight:", ";}p{margin-top:", ";font-weight:", ";}p:nth-last-of-type(-n + 3){margin-top:0;}ol{margin-bottom:", ";}}"], function (props) {
  return props.theme.font.size['body-1'];
}, function (props) {
  return props.theme.font.weight.regular;
}, function (props) {
  return props.theme.size.spacing.lg;
}, function (props) {
  return props.theme.font.weight.bold;
}, function (props) {
  return props.theme.size.spacing.md;
});
export { Instructions };